import { IVaultViewAllLoansDocumentDetailData } from "Features/Vault/VaultInterfaces";

import {
  DocListMersEligibilityContext,
  getAddDocumentEligibility,
} from "../AddDocument/getAddDocumentEligibility";

export interface ReverseDocumentMenuState {
  disabled: boolean;
  disabledReason: string;
  show: boolean;
}

export function getReverseDocumentMenuState(
  document: IVaultViewAllLoansDocumentDetailData,
  mersEligibility?: DocListMersEligibilityContext
): ReverseDocumentMenuState {
  if (!document.mersDocumentType) {
    return { disabled: true, disabledReason: "", show: false };
  }

  if (document.mersStatus === "MersLinkedReversed") {
    return { disabled: true, disabledReason: "", show: false };
  }

  if (document.mersStatus === "MersPending") {
    return {
      disabled: true,
      disabledReason: "Add Document is still in progress.",
      show: true,
    };
  }

  if (document.mersStatus === "MersLinked") {
    if (document.mersReversalEligible) {
      const eligibility = getAddDocumentEligibility(mersEligibility);
      if (!eligibility.eligible) {
        return { disabled: true, disabledReason: eligibility.reason ?? "", show: true };
      }
      return { disabled: false, disabledReason: "", show: true };
    }

    if (document.mersTypeHasPendingAdd) {
      return {
        disabled: true,
        disabledReason: "Add Document is still in progress.",
        show: true,
      };
    }

    return {
      disabled: true,
      disabledReason: "Only the most recently added MERS-linked document of this type can be reversed.",
      show: true,
    };
  }

  return { disabled: true, disabledReason: "", show: false };
}
